import { useQuery } from '@tanstack/react-query'
import { registerConsumers } from '..'
import cacheKeys from '../cacheKeys'

const useRegisteredConsumer = (
  currentPage: number,
  limit: number,
  search: string,
) => {
  return useQuery({
    queryKey: [cacheKeys.REGISTERED_CONSUMERS, currentPage, limit, search],
    queryFn: registerConsumers,
    enabled: !!currentPage && !!limit,
  })
}

export default useRegisteredConsumer
